export const countryConfigHR = {
  home: {
    skeleton: {
      banner: false,
      bubbles: false,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'za-bicikle-i-skutere-1',
    carCollection: 'za-vozace-automobila-2'
  }
};
